<div class="row">
  <div class="col s12">
    <nav class="breadcrumb-nav">
      <div class="nav-wrapper">
        <div class="col s12 breadcrumb-div">
          <a routerLink="/" class="breadcrumb">
            {{ 'UNIVERSAL-NAVIGATION_HOME' | translate }}
          </a>
          <a class="breadcrumb" aria-current="page">
            {{ 'HeaderComponent-DONOR_SERVICES_LINK' | translate }}
          </a>
        </div>
      </div>
    </nav>
    <div class="col s12 divider"></div>
  </div>
</div>

<article class="donors-services-page">
  <section class="hero" aria-labelledby="donors-services-title">
    <div class="hero__content">
      <div class="hero__stat">
        <p class="hero__stat-number">{{ 'DONORS-SERVICES_HERO-STAT' | translate }}</p>
        <p class="hero__stat-copy">{{ 'DONORS-SERVICES_HERO-STAT-COPY' | translate }}</p>
      </div>

      <div class="hero__message">
        <h2 id="donors-services-title">{{ 'DONORS-SERVICES_HERO-TITLE' | translate }}</h2>
        <p>{{ 'DONORS-SERVICES_HERO-BODY' | translate }}</p>
      </div>
    </div>
  </section>

  <section class="services" aria-labelledby="services-heading">
    <div class="services__heading">
      <h2 id="services-heading">{{ 'DONORS-SERVICES_SERVICES-HEADING' | translate }}</h2>
      <a class="services__partner-button" href="mailto:Partner@SmartResponse.org">
        {{ 'DONORS-SERVICES_CTA-PARTNER' | translate }}
      </a>
    </div>

    <div class="services__grid">
      <article class="service-card" *ngFor="let service of services; trackBy: trackByServiceTitle">
        <img class="service-card__icon" [src]="service.icon" alt="" aria-hidden="true" />
        <div class="service-card__copy">
          <h3>{{ service.titleKey | translate }}</h3>
          <p>{{ service.bodyKey | translate }}</p>
        </div>
      </article>
    </div>
  </section>

  <section class="partners" aria-labelledby="partners-heading">
    <p id="partners-heading" class="partners__lead">{{ 'DONORS-SERVICES_PARTNERS-LEAD' | translate }}</p>
    <p class="partners__copy">{{ 'DONORS-SERVICES_PARTNERS-BODY' | translate }}</p>

    <div class="partners__carousel">
      <div class="partners__track">
        <div class="partners__group">
          <div
            class="partners__card"
            *ngFor="let partner of partners; trackBy: trackByPartnerName"
          >
            <img class="partners__logo" [src]="partner.logo" [alt]="partner.name" />
          </div>
        </div>

        <div class="partners__group" aria-hidden="true">
          <div
            class="partners__card"
            *ngFor="let partner of partners; trackBy: trackByPartnerName"
          >
            <img class="partners__logo" [src]="partner.logo" alt="" />
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="get-involved" aria-labelledby="get-involved-heading">
    <div class="get-involved__content">
      <h2 id="get-involved-heading">{{ 'DONORS-SERVICES_GET-INVOLVED-HEADING' | translate }}</h2>
      <div class="get-involved__actions">
        <a class="get-involved__button" [routerLink]="['/dap-donation']">
          {{ 'DONORS-SERVICES_CTA-DONATE' | translate }}
        </a>
        <a class="get-involved__button" href="mailto:Partner@SmartResponse.org">
          {{ 'DONORS-SERVICES_CTA-PARTNER' | translate }}
        </a>
        <a
          class="get-involved__button"
          href="https://www.volunteermatch.org/search/org663759.jsp"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ 'DONORS-SERVICES_CTA-VOLUNTEER' | translate }}
        </a>
      </div>
    </div>
  </section>
</article>
